import CancelDocumentButton from '../Common/CancelDocumentButton';
import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatPrice, convertNumberToWords } from '../../helpers/utility';

import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { commandeActions } from '../../sagas/commandeSlice';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";
import { generateDoc } from '../../helpers/generateDoc';
import DocumentPagination from '../Common/DocumentPagination';
import '../Common/DocumentList.css';

const BonCommandeList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const formBase = location.pathname.startsWith('/sales-module') ? '/sales-module/orders' : '/commandes';
    const dispatch = useDispatch();
    const { list, loading, totalPages, pageNumber, pageSize, totalElements } = useSelector((state) => state.commande);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const { t } = useTranslation();
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const getMonthRange = (monthValue) => {
        if (!monthValue) return { dateFrom: formatDate(todayDate), dateTo: formatDate(tomorrowDate) };
        const [year, month] = monthValue.split('-').map(Number);
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        return { dateFrom: formatDate(firstDay), dateTo: formatDate(lastDay) };
    };
    const searchInputRef = useRef(null);
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: '',
        status: '',
        month: '',
        page: 0,
        size: 10
    });

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(commandeActions.list(payload));
        dispatch(productActions.findAllUnites());

    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);


    useEffect(() => {
        dispatch(commandeActions.list({
            ...filters,
        }));
    }, [filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId, filters.status, filters.page, filters.size]);


    const handleGeneratePdf = (bonCommande) => {
        // First, ask the user whether they want to generate the PDF with TTC or HT prices
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            // If user closes the dialog without choosing, don't generate PDF
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            // Determine if we should show TTC prices (confirmed) or HT prices (canceled)
            const showTTCPrices = result.isConfirmed;

            generateDoc("bon_commande", {
                matjarDoc: {
                    ...bonCommande, lignes: bonCommande.lignes.map(l => ({
                        ...l,
                        unite: unites.find(u => u.code === l.unite)?.libelle
                    }))
                },
                sellerModel: company,
                priceMode: showTTCPrices ? "TTC" : "HT",    // or "TTC"
                open: true,
            });
        });
    };

    const handleShowModal = () => navigate(`${formBase}/new`);
    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];
    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate),
            status: '',
            month: '',
            page: 0,
            size: 10
        });
        debouncedSearch()
    };

    const handleBonLivraison = (commande) => {
        if (!commande.entrepotId) {
            Swal.fire({
                icon: 'warning',
                title: t('commande.noEntrepot', 'Entrepôt non défini'),
                text: t('commande.noEntrepotMessage', 'Veuillez définir un entrepôt pour cette commande avant de la convertir en bon de livraison.'),
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        Swal.fire({
            title: 'Confirmation',
            text: "Cette commande sera convertie en bon de livraison. Voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(commandeActions.validerCommande({
                    id: commande.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Validée!',
                            text: 'La commande a été convertie en bon de livraison avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        // Refresh the list
                        let payload = {
                            ...filters,
                        };
                        dispatch(commandeActions.list(payload));
                    },
                    onError: (error) => {
                        // Add error handling
                        Swal.fire({
                            icon: 'error',
                            title: 'Erreur!',
                            text: `Une erreur est survenue: ${error?.message || 'Veuillez réessayer plus tard.'}`,
                            confirmButtonColor: '#3085d6',
                        });
                    }
                }));
            }
        });
    };

    const handleUpdateCommande = (commande) => navigate(`${formBase}/${commande.id}/edit`);

    const debouncedSearch = () => {
        dispatch(commandeActions.list({
            ...filters,
        }));
    }

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('commande.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}
                                >
                                    <FaPlus className="mr-2" /> {t('commande.newCommande')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
	                                <Row className="mb-3 g-2 align-items-end doc-filter-row">
                                    <Col lg={3} md={4} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('commande.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value,
                                                            page: 0
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null, page: 0 }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="status" className="mb-1">{t('commande.status')}</Label>
                                            <Input
                                                type="select"
                                                id="status"
                                                value={filters.status}
                                                onChange={e => setFilters(f => ({ ...f, status: e.target.value, page: 0 }))}
                                            >
                                                <option value="">{t('common.all', 'Tous')}</option>
                                                <option value="EN_ATTENTE">{t('commande.statusDraft')}</option>
                                                <option value="VALIDE">{t('commande.statusValidated')}</option>
                                                <option value="LIVRE">{t('commande.statusDelivered')}</option>
                                                <option value="ANNULE">{t('commande.statusCancelled')}</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="month" className="mb-1">{t('common.month', 'Mois')}</Label>
                                            <Input
                                                type="month"
                                                id="month"
                                                value={filters.month}
                                                onChange={e => {
                                                    const range = getMonthRange(e.target.value);
                                                    setFilters(f => ({ ...f, month: e.target.value, ...range, page: 0 }));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
	                            <DocumentPagination
	                                pageNumber={pageNumber}
	                                totalPages={totalPages}
	                                totalElements={totalElements}
	                                pageSize={pageSize}
	                                onPageChange={(page) => setFilters(f => ({ ...f, page }))}
	                            />
	                            <div className="doc-list">
                                {list.map((commande) => (
                                    <div className="doc-row" key={commande.id}>
                                        <div className="doc-row-main">
                                            <strong>{commande.numero}</strong>
                                            <span>{t('commande.devis')}: {commande.devisNumero || 'N/A'}</span>
                                            <span>{t('commande.dateCreation')}: {commande.dateCreation || '-'}</span>
                                            <span>{t('commande.dateOperation')}: {commande.dateOperation || 'N/A'}</span>
                                        </div>
                                        <div className="doc-client">
                                            <strong>{commande.clientNom || '-'}</strong>
                                            <span>{t('common.user')}: {commande.createdBy || '-'}</span>
                                        </div>
                                        <div className="doc-amounts">
                                            <div className="doc-amount">
                                                <span>{t('devis.montantTTC')}</span>
                                                <strong>{formatPrice(commande.montantTotalTTC, false)}</strong>
                                            </div>
                                        </div>
                                        <div className="doc-statuses">
                                            {commande.status === 'EN_ATTENTE' && (
                                                <span className="badge bg-secondary">{t('commande.statusDraft')}</span>
                                            )}
                                            {commande.status === 'VALIDE' && (
                                                <span className="badge bg-success">{t('commande.statusValidated')}</span>
                                            )}
                                            {commande.status === 'LIVRE' && (
                                                <span className="badge bg-primary">{t('commande.statusDelivered')}</span>
                                            )}
                                            {commande.status === 'ANNULE' && (
                                                <span className="badge bg-danger">{t('commande.statusCancelled')}</span>
                                            )}
                                        </div>
                                        <div className="doc-actions">
                                            <CancelDocumentButton document={commande} endpoint={`/api/ventes/bon-commande/${commande.id}/annuler`} onCancelled={() => dispatch(commandeActions.list(filters))} />
                                            <Button color="secondary" title={t('commande.downloadPdf')} onClick={() => handleGeneratePdf(commande)} className="doc-icon-btn" size="sm">
                                                <FaFilePdf />
                                            </Button>
                                            {commande.status === 'EN_ATTENTE' && (
                                                <Button color="success" title={t('commande.bonLivraison')} onClick={() => handleBonLivraison(commande)} className="doc-icon-btn" size="sm">
                                                    <FaCheckCircle />
                                                </Button>
                                            )}
                                            <Button color="warning" title={t('commande.edit')} disabled={commande.status === 'ANNULE'} onClick={() => handleUpdateCommande(commande)} size="sm" className="doc-icon-btn">
                                                <FaEdit />
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                                {list.length === 0 && <div className="doc-empty">{t('commande.noCommande')}</div>}
                                {list.length > 0 && (
                                    <div className="doc-row">
                                        <div className="doc-row-main">
                                            <strong>{t('common.totals')}</strong>
                                            <span>{list.length} lignes</span>
                                        </div>
                                        <div className="doc-client" />
                                        <div className="doc-amounts">
                                            <div className="doc-amount">
                                                <span>{t('devis.montantTTC')}</span>
                                                <strong>{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</strong>
                                            </div>
                                        </div>
                                        <div />
                                        <div />
                                    </div>
                                )}
                            </div>
	                        </>)}
                </CardBody>
            </Card>

        </Container>
    );
};

export default BonCommandeList;
